import { queryOptions } from '@tanstack/react-query';
import { apiUsersService } from '#client/services/apiUsersService.js';

export const API_USERS_QUERY_KEY = ['api-users'];

export const getApiUsersQueryOptions = () =>
    queryOptions({
        queryKey: API_USERS_QUERY_KEY,
        queryFn: apiUsersService.fetchApiUsers, // Use service function for fetching users
        staleTime: 10 * 60 * 1000, // 10 minutes
        refetchOnWindowFocus: false,
        retry: false, // Don't retry failed requests for API users to avoid unnecessary load on the server
    });
